// import React, { useState, useEffect } from 'react';
// import { FaSave, FaUpload, FaPlus, FaTrash, FaArrowUp, FaArrowDown } from 'react-icons/fa';

// const AdminAttractionsPanel = () => {
//   // Stan dla danych atrakcji
//   const [attractionsData, setAttractionsData] = useState({
//     slider: {
//       images: [
//         {
//           src: '/images/latarniamorska.jpg',
//           title: 'Latarnia Morska w Rozewiu',
//           subtitle: 'Zabytkowa latarnia z muzeum latarnictwa'
//         },
//         {
//           src: '/images/klifwjastrzebiejgorze.jpg',
//           title: 'Klif w Jastrzębiej Górze',
//           subtitle: 'Malownicze wybrzeże klifowe'
//         },
//         {
//           src: '/images/wawoz.jpg',
//           title: 'Wąwóz Chłapowski',
//           subtitle: 'Piękny rezerwat przyrody'
//         },
//         {
//           src: '/images/plazajastrzebiagora.jpg',
//           title: 'Plaże Jastrzębiej Góry',
//           subtitle: 'Złociste piaski nad Bałtykiem'
//         }
//       ]
//     },
//     details: {
//       title: "Atrakcje Jastrzębiej Góry i okolic",
//       description: "Odkryj niezwykłe miejsca, które warto odwiedzić podczas pobytu w naszej okolicy",
//       categories: [
//         {
//           title: 'Przyroda i krajobrazy',
//           items: [
//             'Lisi Jar',
//             'Wąwóz Chłapowski',
//             'Klif w Jastrzębiej Górze',
//             'Gwiazda Północy',
//             'Wydmy ruchome w Łebie'
//           ],
//           image: '/images/krajobraz.jpg'
//         },
//         {
//           title: 'Zabytki i kultura',
//           items: [
//             'Latarnia Morska w Rozewiu',
//             'Muzeum Latarnictwa',
//             'Promenada Światowida',
//             'Zabytkowe kościoły',
//             'Groty w Mechowie'
//           ],
//           image: '/images/zabytki.jpg'
//         },
//         {
//           title: 'Aktywny wypoczynek',
//           items: [
//             'Plaże Jastrzębiej Góry',
//             'Ścieżki rowerowe i piesze',
//             'Spływy kajakowe',
//             'Jazda konna',
//             'Loty widokowe'
//           ],
//           image: '/images/aktywnywypoczynek.jpg'
//         },
//         {
//           title: 'Atrakcje dla rodzin',
//           items: [
//             'Wodny Park Primavera',
//             'Parki rozrywki',
//             'Plac zabaw nad brzegiem morza',
//             'Rejsy statkiem',
//             'Mini zoo'
//           ],
//           image: '/images/atrakcjedlarodzin.jpg'
//         }
//       ],
//       otherPlaces: [
//         'Dom Whisky w Jastrzębiej Górze',
//         'Półwysep Helski',
//         'Fokarium w Helu',
//         'Muzeum Rybołówstwa',
//         'Ocean Park we Władysławowie',
//         'Rezerwat przyrody Bielawa'
//       ]
//     }
//   });

//   const [message, setMessage] = useState("");
//   const [imageUploading, setImageUploading] = useState({});

//   // Załaduj dane z localStorage przy starcie
//   useEffect(() => {
//     const savedData = localStorage.getItem('attractionsData');
//     if (savedData) {
//       try {
//         setAttractionsData(JSON.parse(savedData));
//       } catch (error) {
//         console.error('Błąd parsowania danych atrakcji:', error);
//       }
//     }
//   }, []);

//   const saveData = () => {
//     localStorage.setItem('attractionsData', JSON.stringify(attractionsData));
//     setMessage("Zmiany zapisane pomyślnie!");
//     setTimeout(() => setMessage(""), 3000);
//   };

//   // Funkcje dla slidera
//   const handleSliderImageUpload = (e, index = null) => {
//     const file = e.target.files[0];
//     if (file) {
//       setImageUploading({ ...imageUploading, slider: true });
      
//       setTimeout(() => {
//         const reader = new FileReader();
//         reader.onload = (event) => {
//           const newImageUrl = event.target.result;
//           const updatedImages = [...attractionsData.slider.images];
          
//           if (index !== null) {
//             updatedImages[index] = {
//               ...updatedImages[index],
//               src: newImageUrl
//             };
//           } else {
//             updatedImages.push({
//               src: newImageUrl,
//               title: 'Nowy slajd',
//               subtitle: 'Opis slajdu'
//             });
//           }
          
//           setAttractionsData({
//             ...attractionsData,
//             slider: {
//               ...attractionsData.slider,
//               images: updatedImages
//             }
//           });
//           setImageUploading({ ...imageUploading, slider: false });
//         };
//         reader.readAsDataURL(file);
//       }, 1000);
//     }
//   };

//   const handleSliderTextChange = (index, field, value) => {
//     const updatedImages = [...attractionsData.slider.images];
//     updatedImages[index] = {
//       ...updatedImages[index],
//       [field]: value
//     };
    
//     setAttractionsData({
//       ...attractionsData,
//       slider: {
//         ...attractionsData.slider,
//         images: updatedImages
//       }
//     });
//   };

//   const removeSliderImage = (index) => {
//     if (attractionsData.slider.images.length <= 1) {
//       setMessage("Musisz mieć przynajmniej jeden slajd!");
//       setTimeout(() => setMessage(""), 3000);
//       return;
//     }
    
//     setAttractionsData({
//       ...attractionsData,
//       slider: {
//         ...attractionsData.slider,
//         images: attractionsData.slider.images.filter((_, i) => i !== index)
//       }
//     });
//   };

//   const moveSliderImage = (index, direction) => {
//     if ((direction === 'up' && index === 0) || 
//         (direction === 'down' && index === attractionsData.slider.images.length - 1)) {
//       return;
//     }

//     const updatedImages = [...attractionsData.slider.images];
//     const targetIndex = direction === 'up' ? index - 1 : index + 1;
    
//     [updatedImages[index], updatedImages[targetIndex]] = 
//     [updatedImages[targetIndex], updatedImages[index]];
    
//     setAttractionsData({
//       ...attractionsData,
//       slider: {
//         ...attractionsData.slider,
//         images: updatedImages
//       }
//     });
//   };

//   // Funkcje dla szczegółów atrakcji
//   const handleDetailsChange = (field, value) => {
//     setAttractionsData({
//       ...attractionsData,
//       details: {
//         ...attractionsData.details,
//         [field]: value
//       }
//     });
//   };

//   const handleCategoryImageUpload = (e, categoryIndex) => {
//     const file = e.target.files[0];
//     if (file) {
//       const uploadKey = `category-${categoryIndex}`;
//       setImageUploading({ ...imageUploading, [uploadKey]: true });
      
//       setTimeout(() => {
//         const reader = new FileReader();
//         reader.onload = (event) => {
//           const newImageUrl = event.target.result;
//           const updatedCategories = [...attractionsData.details.categories];
//           updatedCategories[categoryIndex] = {
//             ...updatedCategories[categoryIndex],
//             image: newImageUrl
//           };
          
//           setAttractionsData({
//             ...attractionsData,
//             details: {
//               ...attractionsData.details,
//               categories: updatedCategories
//             }
//           });
//           setImageUploading({ ...imageUploading, [uploadKey]: false });
//         };
//         reader.readAsDataURL(file);
//       }, 1000);
//     }
//   };

//   const handleCategoryChange = (categoryIndex, field, value) => {
//     const updatedCategories = [...attractionsData.details.categories];
//     updatedCategories[categoryIndex] = {
//       ...updatedCategories[categoryIndex],
//       [field]: value
//     };
    
//     setAttractionsData({
//       ...attractionsData,
//       details: {
//         ...attractionsData.details,
//         categories: updatedCategories
//       }
//     });
//   };

//   const handleCategoryItemChange = (categoryIndex, itemIndex, value) => {
//     const updatedCategories = [...attractionsData.details.categories];
//     const updatedItems = [...updatedCategories[categoryIndex].items];
//     updatedItems[itemIndex] = value;
    
//     updatedCategories[categoryIndex] = {
//       ...updatedCategories[categoryIndex],
//       items: updatedItems
//     };
    
//     setAttractionsData({
//       ...attractionsData,
//       details: {
//         ...attractionsData.details,
//         categories: updatedCategories
//       }
//     });
//   };

//   const addCategoryItem = (categoryIndex) => {
//     const updatedCategories = [...attractionsData.details.categories];
//     updatedCategories[categoryIndex] = {
//       ...updatedCategories[categoryIndex],
//       items: [...updatedCategories[categoryIndex].items, "Nowa atrakcja"]
//     };
    
//     setAttractionsData({
//       ...attractionsData,
//       details: {
//         ...attractionsData.details,
//         categories: updatedCategories
//       }
//     });
//   };

//   const removeCategoryItem = (categoryIndex, itemIndex) => {
//     const updatedCategories = [...attractionsData.details.categories];
//     updatedCategories[categoryIndex] = {
//       ...updatedCategories[categoryIndex],
//       items: updatedCategories[categoryIndex].items.filter((_, i) => i !== itemIndex)
//     };
    
//     setAttractionsData({
//       ...attractionsData,
//       details: {
//         ...attractionsData.details,
//         categories: updatedCategories
//       }
//     });
//   };

//   const handleOtherPlaceChange = (index, value) => {
//     const updatedPlaces = [...attractionsData.details.otherPlaces];
//     updatedPlaces[index] = value;
    
//     setAttractionsData({
//       ...attractionsData,
//       details: {
//         ...attractionsData.details,
//         otherPlaces: updatedPlaces
//       }
//     });
//   };

//   const addOtherPlace = () => {
//     setAttractionsData({
//       ...attractionsData,
//       details: {
//         ...attractionsData.details,
//         otherPlaces: [...attractionsData.details.otherPlaces, "Nowe miejsce"]
//       }
//     });
//   };

//   const removeOtherPlace = (index) => {
//     setAttractionsData({
//       ...attractionsData,
//       details: {
//         ...attractionsData.details,
//         otherPlaces: attractionsData.details.otherPlaces.filter((_, i) => i !== index)
//       }
//     });
//   };

//   return (
//     <div className="min-h-screen bg-gray-100 p-6">
//       <div className="max-w-6xl mx-auto bg-white rounded-lg shadow-md p-6">
//         <h1 className="text-2xl font-bold mb-6 text-gray-800">Panel Administracyjny - Atrakcje</h1>
        
//         {message && (
//           <div className="mb-4 p-3 bg-green-100 text-green-700 rounded">
//             {message}
//           </div>
//         )}
        
//         {/* Sekcja slidera */}
//         <div className="mb-8 p-4 border border-gray-200 rounded-md">
//           <h2 className="text-lg font-semibold mb-4">Slider główny</h2>
          
//           <div className="space-y-6">
//             {attractionsData.slider.images.map((image, index) => (
//               <div key={index} className="p-4 border border-gray-200 rounded-md">
//                 <div className="flex items-center justify-between mb-4">
//                   <h3 className="font-medium">Slajd {index + 1}</h3>
//                   <div className="flex gap-2">
//                     <button
//                       onClick={() => moveSliderImage(index, 'up')}
//                       disabled={index === 0}
//                       className={`p-2 rounded ${index === 0 ? 'bg-gray-200 text-gray-400' : 'bg-gray-200 hover:bg-gray-300'}`}
//                     >
//                       <FaArrowUp />
//                     </button>
//                     <button
//                       onClick={() => moveSliderImage(index, 'down')}
//                       disabled={index === attractionsData.slider.images.length - 1}
//                       className={`p-2 rounded ${index === attractionsData.slider.images.length - 1 ? 'bg-gray-200 text-gray-400' : 'bg-gray-200 hover:bg-gray-300'}`}
//                     >
//                       <FaArrowDown />
//                     </button>
//                     <button
//                       onClick={() => removeSliderImage(index)}
//                       className="p-2 bg-red-100 text-red-600 rounded"
//                     >
//                       <FaTrash />
//                     </button>
//                   </div>
//                 </div>
                
//                 <div className="grid md:grid-cols-2 gap-4 mb-4">
//                   <div>
//                     <label className="block text-sm font-medium text-gray-700 mb-2">Zdjęcie</label>
//                     <div className="flex items-center gap-4">
//                       <div className="w-20 h-20 bg-gray-200 rounded-md overflow-hidden">
//                         <img 
//                           src={image.src} 
//                           alt={`Slajd ${index + 1}`} 
//                           className="w-full h-full object-cover"
//                         />
//                       </div>
//                       <label className="flex flex-col items-center justify-center w-full h-32 border-2 border-dashed border-gray-300 rounded-md cursor-pointer bg-gray-50 hover:bg-gray-100">
//                         {imageUploading.slider ? (
//                           <div className="flex flex-col items-center justify-center">
//                             <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-blue-500 mb-2"></div>
//                             <span className="text-sm">Przesyłanie...</span>
//                           </div>
//                         ) : (
//                           <>
//                             <FaUpload className="w-8 h-8 text-gray-500 mb-2" />
//                             <p className="text-sm text-gray-500 text-center">
//                               <span className="font-semibold">Zmień zdjęcie</span><br />
//                               <span className="text-xs">PNG, JPG (max. 5MB)</span>
//                             </p>
//                             <input 
//                               type="file" 
//                               className="hidden" 
//                               onChange={(e) => handleSliderImageUpload(e, index)} 
//                               accept="image/*" 
//                             />
//                           </>
//                         )}
//                       </label>
//                     </div>
//                   </div>
                  
//                   <div className="space-y-4">
//                     <div>
//                       <label className="block text-sm font-medium text-gray-700 mb-2">Tytuł</label>
//                       <input
//                         type="text"
//                         value={image.title}
//                         onChange={(e) => handleSliderTextChange(index, 'title', e.target.value)}
//                         className="w-full p-2 border border-gray-300 rounded-md"
//                       />
//                     </div>
                    
//                     <div>
//                       <label className="block text-sm font-medium text-gray-700 mb-2">Podtytuł</label>
//                       <input
//                         type="text"
//                         value={image.subtitle}
//                         onChange={(e) => handleSliderTextChange(index, 'subtitle', e.target.value)}
//                         className="w-full p-2 border border-gray-300 rounded-md"
//                       />
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             ))}
            
//             <button
//               onClick={() => handleSliderImageUpload({ target: { files: [null] } })}
//               className="flex items-center gap-2 bg-blue-500 text-white px-4 py-2 rounded-md"
//             >
//               <FaPlus /> Dodaj nowy slajd
//             </button>
//           </div>
//         </div>

//         {/* Sekcja szczegółów atrakcji */}
//         <div className="mb-8 p-4 border border-gray-200 rounded-md">
//           <h2 className="text-lg font-semibold mb-4">Strona szczegółów atrakcji</h2>
          
//           <div className="mb-6">
//             <label className="block text-sm font-medium text-gray-700 mb-2">Tytuł strony</label>
//             <input
//               type="text"
//               value={attractionsData.details.title}
//               onChange={(e) => handleDetailsChange('title', e.target.value)}
//               className="w-full p-3 border border-gray-300 rounded-md"
//             />
//           </div>
          
//           <div className="mb-6">
//             <label className="block text-sm font-medium text-gray-700 mb-2">Opis strony</label>
//             <textarea
//               value={attractionsData.details.description}
//               onChange={(e) => handleDetailsChange('description', e.target.value)}
//               className="w-full p-3 border border-gray-300 rounded-md h-20"
//             />
//           </div>
          
//           <div className="mb-6">
//             <h3 className="font-semibold mb-4">Kategorie atrakcji</h3>
//             <div className="space-y-6">
//               {attractionsData.details.categories.map((category, categoryIndex) => (
//                 <div key={categoryIndex} className="p-4 border border-gray-200 rounded-md">
//                   <h4 className="font-medium mb-4">Kategoria {categoryIndex + 1}</h4>
                  
//                   <div className="grid md:grid-cols-2 gap-4 mb-4">
//                     <div>
//                       <label className="block text-sm font-medium text-gray-700 mb-2">Zdjęcie kategorii</label>
//                       <div className="flex items-center gap-4">
//                         <div className="w-20 h-20 bg-gray-200 rounded-md overflow-hidden">
//                           <img 
//                             src={category.image} 
//                             alt={category.title} 
//                             className="w-full h-full object-cover"
//                           />
//                         </div>
//                         <label className="flex flex-col items-center justify-center w-full h-32 border-2 border-dashed border-gray-300 rounded-md cursor-pointer bg-gray-50 hover:bg-gray-100">
//                           {imageUploading[`category-${categoryIndex}`] ? (
//                             <div className="flex flex-col items-center justify-center">
//                               <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-blue-500 mb-2"></div>
//                               <span className="text-sm">Przesyłanie...</span>
//                             </div>
//                           ) : (
//                             <>
//                               <FaUpload className="w-8 h-8 text-gray-500 mb-2" />
//                               <p className="text-sm text-gray-500 text-center">
//                                 <span className="font-semibold">Zmień zdjęcie</span><br />
//                                 <span className="text-xs">PNG, JPG (max. 5MB)</span>
//                               </p>
//                               <input 
//                                 type="file" 
//                                 className="hidden" 
//                                 onChange={(e) => handleCategoryImageUpload(e, categoryIndex)} 
//                                 accept="image/*" 
//                               />
//                             </>
//                           )}
//                         </label>
//                       </div>
//                     </div>
                    
//                     <div className="space-y-4">
//                       <div>
//                         <label className="block text-sm font-medium text-gray-700 mb-2">Tytuł kategorii</label>
//                         <input
//                           type="text"
//                           value={category.title}
//                           onChange={(e) => handleCategoryChange(categoryIndex, 'title', e.target.value)}
//                           className="w-full p-2 border border-gray-300 rounded-md"
//                         />
//                       </div>
//                     </div>
//                   </div>
                  
//                   <div className="mb-4">
//                     <label className="block text-sm font-medium text-gray-700 mb-2">Atrakcje w kategorii</label>
//                     <div className="space-y-2">
//                       {category.items.map((item, itemIndex) => (
//                         <div key={itemIndex} className="flex items-center gap-2">
//                           <input
//                             type="text"
//                             value={item}
//                             onChange={(e) => handleCategoryItemChange(categoryIndex, itemIndex, e.target.value)}
//                             className="flex-1 p-2 border border-gray-300 rounded-md"
//                           />
//                           <button
//                             onClick={() => removeCategoryItem(categoryIndex, itemIndex)}
//                             className="p-2 bg-red-100 text-red-600 rounded-md"
//                           >
//                             <FaTrash />
//                           </button>
//                         </div>
//                       ))}
//                     </div>
//                     <button
//                       onClick={() => addCategoryItem(categoryIndex)}
//                       className="mt-2 flex items-center gap-2 bg-blue-500 text-white px-3 py-1 rounded-md text-sm"
//                     >
//                       <FaPlus /> Dodaj atrakcję
//                     </button>
//                   </div>
//                 </div>
//               ))}
//             </div>
//           </div>
          
//           <div className="mb-6">
//             <h3 className="font-semibold mb-4">Inne wyjątkowe miejsca</h3>
//             <div className="space-y-2">
//               {attractionsData.details.otherPlaces.map((place, index) => (
//                 <div key={index} className="flex items-center gap-2">
//                   <input
//                     type="text"
//                     value={place}
//                     onChange={(e) => handleOtherPlaceChange(index, e.target.value)}
//                     className="flex-1 p-2 border border-gray-300 rounded-md"
//                   />
//                   <button
//                     onClick={() => removeOtherPlace(index)}
//                     className="p-2 bg-red-100 text-red-600 rounded-md"
//                   >
//                     <FaTrash />
//                   </button>
//                 </div>
//               ))}
//             </div>
//             <button
//               onClick={addOtherPlace}
//               className="mt-2 flex items-center gap-2 bg-blue-500 text-white px-3 py-1 rounded-md text-sm"
//             >
//               <FaPlus /> Dodaj miejsce
//             </button>
//           </div>
//         </div>

//         {/* Zapisywanie */}
//         <div className="flex justify-end">
//           <button
//             onClick={saveData}
//             className="flex items-center gap-2 bg-green-500 hover:bg-green-600 text-white font-medium py-2 px-4 rounded-md"
//           >
//             <FaSave /> Zapisz zmiany
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default AdminAttractionsPanel;

import React, { useState, useEffect } from 'react';
import { FaSave, FaUpload, FaPlus, FaTrash, FaArrowUp, FaArrowDown } from 'react-icons/fa';

const AdminAttractionsPanel = () => {
  const API_BASE = 'http://localhost/api';

  // Stan dla danych atrakcji
  const [attractionsData, setAttractionsData] = useState({
    slider: {
      images: [
        {
          src: '/images/latarniamorska.jpg',
          title: 'Latarnia Morska w Rozewiu',
          subtitle: 'Zabytkowa latarnia z muzeum latarnictwa'
        },
        {
          src: '/images/klifwjastrzebiejgorze.jpg',
          title: 'Klif w Jastrzębiej Górze',
          subtitle: 'Malownicze wybrzeże klifowe'
        },
        {
          src: '/images/wawoz.jpg',
          title: 'Wąwóz Chłapowski',
          subtitle: 'Piękny rezerwat przyrody'
        },
        {
          src: '/images/plazajastrzebiagora.jpg',
          title: 'Plaże Jastrzębiej Góry',
          subtitle: 'Złociste piaski nad Bałtykiem'
        }
      ]
    },
    details: {
      title: "Atrakcje Jastrzębiej Góry i okolic",
      description: "Odkryj niezwykłe miejsca, które warto odwiedzić podczas pobytu w naszej okolicy",
      categories: [
        {
          title: 'Przyroda i krajobrazy',
          items: [
            'Lisi Jar',
            'Wąwóz Chłapowski',
            'Klif w Jastrzębiej Górze',
            'Gwiazda Północy',
            'Wydmy ruchome w Łebie'
          ],
          image: '/images/krajobraz.jpg'
        },
        {
          title: 'Zabytki i kultura',
          items: [
            'Latarnia Morska w Rozewiu',
            'Muzeum Latarnictwa',
            'Promenada Światowida',
            'Zabytkowe kościoły',
            'Groty w Mechowie'
          ],
          image: '/images/zabytki.jpg'
        },
        {
          title: 'Aktywny wypoczynek',
          items: [
            'Plaże Jastrzębiej Góry',
            'Ścieżki rowerowe i piesze',
            'Spływy kajakowe',
            'Jazda konna',
            'Loty widokowe'
          ],
          image: '/images/aktywnywypoczynek.jpg'
        },
        {
          title: 'Atrakcje dla rodzin',
          items: [
            'Wodny Park Primavera',
            'Parki rozrywki',
            'Plac zabaw nad brzegiem morza',
            'Rejsy statkiem',
            'Mini zoo'
          ],
          image: '/images/atrakcjedlarodzin.jpg'
        }
      ],
      otherPlaces: [
        'Dom Whisky w Jastrzębiej Górze',
        'Półwysep Helski',
        'Fokarium w Helu',
        'Muzeum Rybołówstwa',
        'Ocean Park we Władysławowie',
        'Rezerwat przyrody Bielawa'
      ]
    }
  });

  const [message, setMessage] = useState("");
  const [imageUploading, setImageUploading] = useState({});
  const [loading, setLoading] = useState(true);

  // Załaduj dane z serwera
  useEffect(() => {
    const fetchAttractionsData = async () => {
      try {
        setLoading(true);
        const response = await fetch(`${API_BASE}/attractions.php`);
        
        if (!response.ok) {
          throw new Error('Błąd podczas pobierania danych atrakcji');
        }
        
        const data = await response.json();
        setAttractionsData(data);
      } catch (error) {
        console.error('Błąd ładowania danych atrakcji:', error);
        setMessage('Błąd połączenia z serwerem - używam domyślnych danych');
        setTimeout(() => setMessage(""), 5000);
      } finally {
        setLoading(false);
      }
    };

    fetchAttractionsData();
  }, []);

  // Zapisz dane na serwerze
  const saveData = () => {
    fetch(`${API_BASE}/attractions.php`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(attractionsData),
    })
    .then(response => {
      if (!response.ok) {
        throw new Error('Błąd serwera');
      }
      return response.json();
    })
    .then(data => {
      setMessage(data.message || "Zmiany zapisane pomyślnie!");
      setTimeout(() => setMessage(""), 3000);
    })
    .catch(error => {
      setMessage("Błąd podczas zapisywania danych");
      console.error('Błąd:', error);
      setTimeout(() => setMessage(""), 5000);
    });
  };

  // Funkcje dla slidera
  const handleSliderImageUpload = (e, index = null) => {
    const file = e.target.files[0];
    if (file) {
      setImageUploading({ ...imageUploading, slider: true });
      
      const formData = new FormData();
      formData.append('image', file);
      
      fetch(`${API_BASE}/upload-attractions.php`, {
        method: 'POST',
        body: formData,
      })
      .then(response => {
        if (!response.ok) {
          throw new Error('Błąd serwera');
        }
        return response.json();
      })
      .then(data => {
        if (data.success) {
          const imageUrl = data.url.startsWith('http') ? data.url : `http://localhost${data.url}`;
          const updatedImages = [...attractionsData.slider.images];
          
          if (index !== null) {
            updatedImages[index] = {
              ...updatedImages[index],
              src: imageUrl
            };
          } else {
            updatedImages.push({
              src: imageUrl,
              title: 'Nowy slajd',
              subtitle: 'Opis slajdu'
            });
          }
          
          setAttractionsData({
            ...attractionsData,
            slider: {
              ...attractionsData.slider,
              images: updatedImages
            }
          });
          setMessage("Obrazek slidera przesłany pomyślnie!");
        } else {
          setMessage(data.error || "Błąd podczas przesyłania obrazka slidera");
        }
        setImageUploading({ ...imageUploading, slider: false });
        setTimeout(() => setMessage(""), 3000);
      })
      .catch(error => {
        setMessage("Błąd podczas przesyłania obrazka slidera");
        setImageUploading({ ...imageUploading, slider: false });
        setTimeout(() => setMessage(""), 5000);
      });
    }
  };

  const handleSliderTextChange = (index, field, value) => {
    const updatedImages = [...attractionsData.slider.images];
    updatedImages[index] = {
      ...updatedImages[index],
      [field]: value
    };
    
    setAttractionsData({
      ...attractionsData,
      slider: {
        ...attractionsData.slider,
        images: updatedImages
      }
    });
  };

  const removeSliderImage = (index) => {
    if (attractionsData.slider.images.length <= 1) {
      setMessage("Musisz mieć przynajmniej jeden slajd!");
      setTimeout(() => setMessage(""), 3000);
      return;
    }
    
    setAttractionsData({
      ...attractionsData,
      slider: {
        ...attractionsData.slider,
        images: attractionsData.slider.images.filter((_, i) => i !== index)
      }
    });
  };

  const moveSliderImage = (index, direction) => {
    if ((direction === 'up' && index === 0) || 
        (direction === 'down' && index === attractionsData.slider.images.length - 1)) {
      return;
    }

    const updatedImages = [...attractionsData.slider.images];
    const targetIndex = direction === 'up' ? index - 1 : index + 1;
    
    [updatedImages[index], updatedImages[targetIndex]] = 
    [updatedImages[targetIndex], updatedImages[index]];
    
    setAttractionsData({
      ...attractionsData,
      slider: {
        ...attractionsData.slider,
        images: updatedImages
      }
    });
  };

  // Funkcje dla szczegółów atrakcji
  const handleDetailsChange = (field, value) => {
    setAttractionsData({
      ...attractionsData,
      details: {
        ...attractionsData.details,
        [field]: value
      }
    });
  };

  const handleCategoryImageUpload = (e, categoryIndex) => {
    const file = e.target.files[0];
    if (file) {
      const uploadKey = `category-${categoryIndex}`;
      setImageUploading({ ...imageUploading, [uploadKey]: true });
      
      const formData = new FormData();
      formData.append('image', file);
      
      fetch(`${API_BASE}/upload-attractions.php`, {
        method: 'POST',
        body: formData,
      })
      .then(response => {
        if (!response.ok) {
          throw new Error('Błąd serwera');
        }
        return response.json();
      })
      .then(data => {
        if (data.success) {
          const imageUrl = data.url.startsWith('http') ? data.url : `http://localhost${data.url}`;
          const updatedCategories = [...attractionsData.details.categories];
          updatedCategories[categoryIndex] = {
            ...updatedCategories[categoryIndex],
            image: imageUrl
          };
          
          setAttractionsData({
            ...attractionsData,
            details: {
              ...attractionsData.details,
              categories: updatedCategories
            }
          });
          setMessage("Obrazek kategorii przesłany pomyślnie!");
        } else {
          setMessage(data.error || "Błąd podczas przesyłania obrazka kategorii");
        }
        setImageUploading({ ...imageUploading, [uploadKey]: false });
        setTimeout(() => setMessage(""), 3000);
      })
      .catch(error => {
        setMessage("Błąd podczas przesyłania obrazka kategorii");
        setImageUploading({ ...imageUploading, [uploadKey]: false });
        setTimeout(() => setMessage(""), 5000);
      });
    }
  };

  const handleCategoryChange = (categoryIndex, field, value) => {
    const updatedCategories = [...attractionsData.details.categories];
    updatedCategories[categoryIndex] = {
      ...updatedCategories[categoryIndex],
      [field]: value
    };
    
    setAttractionsData({
      ...attractionsData,
      details: {
        ...attractionsData.details,
        categories: updatedCategories
      }
    });
  };

  const handleCategoryItemChange = (categoryIndex, itemIndex, value) => {
    const updatedCategories = [...attractionsData.details.categories];
    const updatedItems = [...updatedCategories[categoryIndex].items];
    updatedItems[itemIndex] = value;
    
    updatedCategories[categoryIndex] = {
      ...updatedCategories[categoryIndex],
      items: updatedItems
    };
    
    setAttractionsData({
      ...attractionsData,
      details: {
        ...attractionsData.details,
        categories: updatedCategories
      }
    });
  };

  const addCategoryItem = (categoryIndex) => {
    const updatedCategories = [...attractionsData.details.categories];
    updatedCategories[categoryIndex] = {
      ...updatedCategories[categoryIndex],
      items: [...updatedCategories[categoryIndex].items, "Nowa atrakcja"]
    };
    
    setAttractionsData({
      ...attractionsData,
      details: {
        ...attractionsData.details,
        categories: updatedCategories
      }
    });
  };

  const removeCategoryItem = (categoryIndex, itemIndex) => {
    const updatedCategories = [...attractionsData.details.categories];
    updatedCategories[categoryIndex] = {
      ...updatedCategories[categoryIndex],
      items: updatedCategories[categoryIndex].items.filter((_, i) => i !== itemIndex)
    };
    
    setAttractionsData({
      ...attractionsData,
      details: {
        ...attractionsData.details,
        categories: updatedCategories
      }
    });
  };

  const handleOtherPlaceChange = (index, value) => {
    const updatedPlaces = [...attractionsData.details.otherPlaces];
    updatedPlaces[index] = value;
    
    setAttractionsData({
      ...attractionsData,
      details: {
        ...attractionsData.details,
        otherPlaces: updatedPlaces
      }
    });
  };

  const addOtherPlace = () => {
    setAttractionsData({
      ...attractionsData,
      details: {
        ...attractionsData.details,
        otherPlaces: [...attractionsData.details.otherPlaces, "Nowe miejsce"]
      }
    });
  };

  const removeOtherPlace = (index) => {
    setAttractionsData({
      ...attractionsData,
      details: {
        ...attractionsData.details,
        otherPlaces: attractionsData.details.otherPlaces.filter((_, i) => i !== index)
      }
    });
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-100 p-6">
        <div className="max-w-6xl mx-auto bg-white rounded-lg shadow-md p-6">
          <div className="flex justify-center items-center h-64">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500"></div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-100 p-6">
      <div className="max-w-6xl mx-auto bg-white rounded-lg shadow-md p-6">
        <h1 className="text-2xl font-bold mb-6 text-gray-800">Panel Administracyjny - Atrakcje</h1>
        
        {message && (
          <div className={`mb-4 p-3 rounded ${
            message.includes('Błąd') ? 'bg-red-100 text-red-700' : 'bg-green-100 text-green-700'
          }`}>
            {message}
          </div>
        )}
        
        {/* Sekcja slidera */}
        <div className="mb-8 p-4 border border-gray-200 rounded-md">
          <h2 className="text-lg font-semibold mb-4">Slider główny</h2>
          
          <div className="space-y-6">
            {attractionsData.slider.images.map((image, index) => (
              <div key={index} className="p-4 border border-gray-200 rounded-md">
                <div className="flex items-center justify-between mb-4">
                  <h3 className="font-medium">Slajd {index + 1}</h3>
                  <div className="flex gap-2">
                    <button
                      onClick={() => moveSliderImage(index, 'up')}
                      disabled={index === 0}
                      className={`p-2 rounded ${index === 0 ? 'bg-gray-200 text-gray-400' : 'bg-gray-200 hover:bg-gray-300'}`}
                    >
                      <FaArrowUp />
                    </button>
                    <button
                      onClick={() => moveSliderImage(index, 'down')}
                      disabled={index === attractionsData.slider.images.length - 1}
                      className={`p-2 rounded ${index === attractionsData.slider.images.length - 1 ? 'bg-gray-200 text-gray-400' : 'bg-gray-200 hover:bg-gray-300'}`}
                    >
                      <FaArrowDown />
                    </button>
                    <button
                      onClick={() => removeSliderImage(index)}
                      className="p-2 bg-red-100 text-red-600 rounded"
                    >
                      <FaTrash />
                    </button>
                  </div>
                </div>
                
                <div className="grid md:grid-cols-2 gap-4 mb-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">Zdjęcie</label>
                    <div className="flex items-center gap-4">
                      <div className="w-20 h-20 bg-gray-200 rounded-md overflow-hidden">
                        <img 
                          src={image.src} 
                          alt={`Slajd ${index + 1}`} 
                          className="w-full h-full object-cover"
                          onError={(e) => {
                            e.target.src = '/images/placeholder.jpg';
                          }}
                        />
                      </div>
                      <label className="flex flex-col items-center justify-center w-full h-32 border-2 border-dashed border-gray-300 rounded-md cursor-pointer bg-gray-50 hover:bg-gray-100">
                        {imageUploading.slider ? (
                          <div className="flex flex-col items-center justify-center">
                            <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-blue-500 mb-2"></div>
                            <span className="text-sm">Przesyłanie...</span>
                          </div>
                        ) : (
                          <>
                            <FaUpload className="w-8 h-8 text-gray-500 mb-2" />
                            <p className="text-sm text-gray-500 text-center">
                              <span className="font-semibold">Zmień zdjęcie</span><br />
                              <span className="text-xs">PNG, JPG (max. 5MB)</span>
                            </p>
                            <input 
                              type="file" 
                              className="hidden" 
                              onChange={(e) => handleSliderImageUpload(e, index)} 
                              accept="image/*" 
                            />
                          </>
                        )}
                      </label>
                    </div>
                  </div>
                  
                  <div className="space-y-4">
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">Tytuł</label>
                      <input
                        type="text"
                        value={image.title}
                        onChange={(e) => handleSliderTextChange(index, 'title', e.target.value)}
                        className="w-full p-2 border border-gray-300 rounded-md"
                      />
                    </div>
                    
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">Podtytuł</label>
                      <input
                        type="text"
                        value={image.subtitle}
                        onChange={(e) => handleSliderTextChange(index, 'subtitle', e.target.value)}
                        className="w-full p-2 border border-gray-300 rounded-md"
                      />
                    </div>
                  </div>
                </div>
              </div>
            ))}
            
            <button
              onClick={() => handleSliderImageUpload({ target: { files: [null] } })}
              className="flex items-center gap-2 bg-blue-500 text-white px-4 py-2 rounded-md"
            >
              <FaPlus /> Dodaj nowy slajd
            </button>
          </div>
        </div>

        {/* Sekcja szczegółów atrakcji */}
        <div className="mb-8 p-4 border border-gray-200 rounded-md">
          <h2 className="text-lg font-semibold mb-4">Strona szczegółów atrakcji</h2>
          
          <div className="mb-6">
            <label className="block text-sm font-medium text-gray-700 mb-2">Tytuł strony</label>
            <input
              type="text"
              value={attractionsData.details.title}
              onChange={(e) => handleDetailsChange('title', e.target.value)}
              className="w-full p-3 border border-gray-300 rounded-md"
            />
          </div>
          
          <div className="mb-6">
            <label className="block text-sm font-medium text-gray-700 mb-2">Opis strony</label>
            <textarea
              value={attractionsData.details.description}
              onChange={(e) => handleDetailsChange('description', e.target.value)}
              className="w-full p-3 border border-gray-300 rounded-md h-20"
            />
          </div>
          
          <div className="mb-6">
            <h3 className="font-semibold mb-4">Kategorie atrakcji</h3>
            <div className="space-y-6">
              {attractionsData.details.categories.map((category, categoryIndex) => (
                <div key={categoryIndex} className="p-4 border border-gray-200 rounded-md">
                  <h4 className="font-medium mb-4">Kategoria {categoryIndex + 1}</h4>
                  
                  <div className="grid md:grid-cols-2 gap-4 mb-4">
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">Zdjęcie kategorii</label>
                      <div className="flex items-center gap-4">
                        <div className="w-20 h-20 bg-gray-200 rounded-md overflow-hidden">
                          <img 
                            src={category.image} 
                            alt={category.title} 
                            className="w-full h-full object-cover"
                            onError={(e) => {
                              e.target.src = '/images/placeholder.jpg';
                            }}
                          />
                        </div>
                        <label className="flex flex-col items-center justify-center w-full h-32 border-2 border-dashed border-gray-300 rounded-md cursor-pointer bg-gray-50 hover:bg-gray-100">
                          {imageUploading[`category-${categoryIndex}`] ? (
                            <div className="flex flex-col items-center justify-center">
                              <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-blue-500 mb-2"></div>
                              <span className="text-sm">Przesyłanie...</span>
                            </div>
                          ) : (
                            <>
                              <FaUpload className="w-8 h-8 text-gray-500 mb-2" />
                              <p className="text-sm text-gray-500 text-center">
                                <span className="font-semibold">Zmień zdjęcie</span><br />
                                <span className="text-xs">PNG, JPG (max. 5MB)</span>
                              </p>
                              <input 
                                type="file" 
                                className="hidden" 
                                onChange={(e) => handleCategoryImageUpload(e, categoryIndex)} 
                                accept="image/*" 
                              />
                            </>
                          )}
                        </label>
                      </div>
                    </div>
                    
                    <div className="space-y-4">
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">Tytuł kategorii</label>
                        <input
                          type="text"
                          value={category.title}
                          onChange={(e) => handleCategoryChange(categoryIndex, 'title', e.target.value)}
                          className="w-full p-2 border border-gray-300 rounded-md"
                        />
                      </div>
                    </div>
                  </div>
                  
                  <div className="mb-4">
                    <label className="block text-sm font-medium text-gray-700 mb-2">Atrakcje w kategorii</label>
                    <div className="space-y-2">
                      {category.items.map((item, itemIndex) => (
                        <div key={itemIndex} className="flex items-center gap-2">
                          <input
                            type="text"
                            value={item}
                            onChange={(e) => handleCategoryItemChange(categoryIndex, itemIndex, e.target.value)}
                            className="flex-1 p-2 border border-gray-300 rounded-md"
                          />
                          <button
                            onClick={() => removeCategoryItem(categoryIndex, itemIndex)}
                            className="p-2 bg-red-100 text-red-600 rounded-md"
                          >
                            <FaTrash />
                          </button>
                        </div>
                      ))}
                    </div>
                    <button
                      onClick={() => addCategoryItem(categoryIndex)}
                      className="mt-2 flex items-center gap-2 bg-blue-500 text-white px-3 py-1 rounded-md text-sm"
                    >
                      <FaPlus /> Dodaj atrakcję
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </div>
          
          <div className="mb-6">
            <h3 className="font-semibold mb-4">Inne wyjątkowe miejsca</h3>
            <div className="space-y-2">
              {attractionsData.details.otherPlaces.map((place, index) => (
                <div key={index} className="flex items-center gap-2">
                  <input
                    type="text"
                    value={place}
                    onChange={(e) => handleOtherPlaceChange(index, e.target.value)}
                    className="flex-1 p-2 border border-gray-300 rounded-md"
                  />
                  <button
                    onClick={() => removeOtherPlace(index)}
                    className="p-2 bg-red-100 text-red-600 rounded-md"
                  >
                    <FaTrash />
                  </button>
                </div>
              ))}
            </div>
            <button
              onClick={addOtherPlace}
              className="mt-2 flex items-center gap-2 bg-blue-500 text-white px-3 py-1 rounded-md text-sm"
            >
              <FaPlus /> Dodaj miejsce
            </button>
          </div>
        </div>

        {/* Zapisywanie */}
        <div className="flex justify-end">
          <button
            onClick={saveData}
            className="flex items-center gap-2 bg-green-500 hover:bg-green-600 text-white font-medium py-2 px-4 rounded-md"
          >
            <FaSave /> Zapisz zmiany
          </button>
        </div>
      </div>
    </div>
  );
};

export default AdminAttractionsPanel;